import { render, staticRenderFns } from "./signup-list.vue?vue&type=template&id=62413660&scoped=true"
import script from "./signup-list.vue?vue&type=script&lang=js"
export * from "./signup-list.vue?vue&type=script&lang=js"
import style0 from "./signup-list.vue?vue&type=style&index=0&id=62413660&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "62413660",
  null
  
)

export default component.exports